<!-- src/app/components/press-release-list/press-release-list.component.html -->
<div class="pr-list">
  <div class="pr-list__header">
    <h2>Press Releases</h2>
    <span class="pr-list__count" *ngIf="pressReleases.length > 0">
      {{ pressReleases.length }} release{{ pressReleases.length !== 1 ? 's' : '' }}
    </span>
  </div>

  <!-- EMPTY STATE -->
  <div *ngIf="pressReleases.length === 0" class="pr-empty">
    <div class="pr-empty__icon">📰</div>
    <div class="pr-empty__title">No press releases yet</div>
    <p class="pr-empty__text">Check back soon for official campaign announcements and updates.</p>
    <a routerLink="/contact" class="pr-empty__cta">Contact the Campaign</a>
  </div>

  <!-- RELEASES -->
  <div
    *ngFor="let release of pressReleases; let i = index"
    class="pr-card"
    [class.pr-card--featured]="i === 0"
    (click)="release.id ? navigateToRelease(release) : null"
  >
    <div class="pr-card__meta">
      <span class="pr-tag" [class.pr-tag--latest]="i === 0">{{ i === 0 ? 'Latest' : 'Press Release' }}</span>
      <span class="pr-card__date">{{ release.date | date: 'MMMM d, yyyy' }}</span>
    </div>
    <h3 class="pr-card__title">
      <a
        *ngIf="release.id"
        [routerLink]="['/newsroom', getReleaseSlug(release)]"
        (click)="$event.stopPropagation()"
      >{{ release.title }}</a>
      <span *ngIf="!release.id">{{ release.title }}</span>
    </h3>
    <p class="pr-card__summary">{{ release.summary }}</p>
    <a
      *ngIf="release.id"
      [routerLink]="['/newsroom', getReleaseSlug(release)]"
      (click)="$event.stopPropagation()"
      class="pr-card__cta"
    >Read Full Release <span class="pr-card__cta-arrow">→</span></a>
  </div>
</div>
